export const spoVersion: '2.23.2' | undefined = window['data']?.version;
export const matomoConfig: { MATOMO_URL: string, ANALYTICS_ID: string } | undefined = window['matomoData'];
